import type React from 'react';
import {
  Breadcrumbs,
  Button,
  Panel,
  PanelBody,
  PanelHeader
} from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { useState } from 'react';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import { PATH } from '~/pages/vendors/settings';
import SettingStyles from '../SettingStyle.module.scss';
import { LineUserAccounts } from '~/components/specifics/vendors/settings/line_user_accounts/LineUserAccounts';

export const Page: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <VendorLayoutV2>
      <VendorSettingLayout>
        <div className={SettingStyles.SpBreadcrumbsWrapper}>
          <Breadcrumbs
            items={[
              { label: '設定一覧', as: Link, href: PATH },
              { label: 'LINE設定' }
            ]}
          />
        </div>
        <Panel>
          <PanelHeader
            rightArea={
              <Button
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >
                追加
              </Button>
            }
            title="LINEアカウント設定"
          />
          <PanelBody>
            <LineUserAccounts
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
            />
          </PanelBody>
        </Panel>
      </VendorSettingLayout>
    </VendorLayoutV2>
  );
};
